import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    const self = this;
    this.activeClass = 'fancy-options__option--active';
    this.inputTargets.forEach((field) => {
      const { icon } = field.dataset;
      const { description } = field.dataset;
      const label = field.parentElement.querySelector('label');
      const option = field.closest('.fancy-options__option');
      $(option).on('click', () => {
        $(field).prop('checked', 'checked');
        self.toggleChoice();
      });
      if (icon !== undefined) {
        $(label).before(`<img class="fancy-options__icon" src="${icon}" />`);
      }
      if (description !== undefined) {
        $(label).after(
          `<small class="fancy-options__description">${description}</small>`
        );
      }
    });
  }

  toggleChoice() {
    this.inputTargets.forEach((field) => {
      const option = field.closest('.fancy-options__option');
      const selected = $(field).is(':checked');
      if (selected === true) {
        $(option).addClass(this.activeClass);
      } else {
        $(option).removeClass(this.activeClass);
      }
    });
  }
}
